import client from '@libs/HttpClient';
class HRScoringParameterService {
  static listHRScoringParameter(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];
    const employeeType = request.queryKey[4];
    return client.get(
      `/hr-scoring-parameters?search=${searchText}&page=${page_no}&status=${status}&employeeType=${employeeType}`,
      request
    );
  }

  static addHRScoringParameter(request) {
    return client.post('/hr-scoring-parameters', request);
  }

  static showHRScoringParameter(params) {
    return client.get(`/hr-scoring-parameters/${params}`);
  }

  static viewHRScoringParameter(params) {
    return client.get(`/hr-scoring-parameters/${params}/edit`);
  }

  static updateHRScoringParameter(request) {
    return client.put(`/hr-scoring-parameters/${request.id}`, request);
  }

  static deleteHRScoringParameter(request) {
    return client.delete(`/hr-scoring-parameters/${request.id}`, request);
  }

  static changeStatusHRScoringParameter(request) {
    return client.patch(`/hr-scoring-parameters/change-status/${request.id}`, request);
  }

  static getGraphData(request) {
    const employeeId = request.queryKey[1];
    const startDate = request.queryKey[2];
    const endDate = request.queryKey[3];
    const parameters = request.queryKey[4];
    const scoredBy = request.queryKey[5];

    const params = new URLSearchParams();

    if (employeeId) {
      params.append('employee_id', employeeId);
    }

    if (startDate) {
      params.append('start_date', startDate);
    }

    if (endDate) {
      params.append('end_date', endDate);
    }

    if (parameters && parameters.length > 0) {
      parameters.forEach(param => {
        params.append('parameters[]', param);
      });
    }

    if (scoredBy) {
      params.append('scored_by', scoredBy);
    }

    return client.get(`/hr-scoring/graph-data?${params.toString()}`);
  }

  static getMyGraphData(request) {
    const startDate = request.queryKey[1];
    const endDate = request.queryKey[2];
    const parameters = request.queryKey[3];

    const paramString =
      parameters && parameters.length > 0
        ? `&parameters[]=${parameters.join('&parameters[]=')}`
        : '';

    return client.get(
      `/hr-scoring/my-graph-data${startDate || endDate || (parameters && parameters.length > 0)
        ? `?${[
          startDate ? `start_date=${startDate}` : '',
          endDate ? `end_date=${endDate}` : '',
          parameters && parameters.length > 0
            ? `parameters[]=${parameters.join('&parameters[]=')}`
            : '',
        ]
          .filter(Boolean)
          .join('&')}`
        : ''
      }`
    );
  }

  static getAvailableMonths() {
    return client.get('/hr-scoring/available-months');
  }

  static getEmployeeAvailableMonths(request) {
    const employeeId = request.queryKey[1];

    const params = new URLSearchParams();
    if (employeeId) params.append('employee_id', employeeId);

    return client.get(
      `/hr-scoring/employee-available-months?${params.toString()}`
    );
  }
}
export { HRScoringParameterService };
